import SimpleHeader from '../../components/SimpleHeader/SimpleHeader.jsx';
import Footer from '../../components/Footer/Footer.jsx';
import styles from './PrivacyPage.module.css';

/**
 * 개인정보처리방침 페이지 (원본: WWW/privacy.html)
 * 공고일 2026.06.24 / 시행일 2026.07.01
 * 2026.10.12 문구 수정 (개인정보취급방침수정.pptx 요청 반영, 공고일/시행일은 요청서에 없어 유지)
 */
export default function PrivacyPage() {
  return (
    <>
      <SimpleHeader />

      <main className={styles.main}>
        <div className="wrap">
          <h1 className={styles.h1}>개인정보처리방침</h1>
          <p className={styles.updated}>시행일자: 2026년 07월 01일</p>

          <div className={styles.intro}>
            <p>
              ㈜비상교육 잉글리시팝(이하 &lsquo;잉글리시팝&rsquo;)은 이용자의 개인 정보를 소중하게 생각하고, 이용자의
              개인정보를 보호하기 위하여 항상 최선을 다하고 있습니다. 잉글리시팝은 정보통신서비스제공자가 준수하여야
              하는 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』, 『개인정보보호법』, 『통신비밀보호법』 등 관련
              법령상의 개인정보보호 규정을 준수하고 있습니다.
            </p>
            <p>
              잉글리시팝은 이용자의 권리를 적극적으로 보장하며, 개인정보의 처리(수집·이용·제공·파기), 보호조치, 고충
              처리에 대한 내용을 다음과 같이 개인정보처리방침을 통하여 알려드립니다.
            </p>
          </div>

          {/* 1. 개인정보의 수집 */}
          <section className={styles.article}>
            <h2 className={styles.h2}>1. 개인정보의 수집</h2>

            <h3 className={styles.h3}>① 개인정보 수집 원칙</h3>
            <ul className={styles.plain}>
              <li>
                잉글리시팝은 서비스 제공에 필요한 최소한의 개인정보를 필수항목과 선택항목으로 구분하여 수집하며, 개인정보 보호법 등 관계 법령에서 정한 적법한 처리 근거에 따라 개인정보를 수집·이용합니다. 정보주체의 동의가 필요한 경우에는 개인정보의 수집·이용 목적, 수집 항목, 보유·이용기간 등 필요한 사항을 사전에 안내하고 동의를 받습니다.
              </li>
            </ul>
            <p className={styles.note}>※ 필수항목과 선택항목</p>
            <ul className={styles.plain}>
              <li>필수항목: 서비스의 본질적 기능을 수행하기 위해 필요한 정보</li>
              <li>선택항목: 부가적인 서비스 제공을 위해 추가로 수집하는 정보로서, 입력하지 않거나 동의하지 않아도 기본적인 서비스 이용에는 제한이 없는 정보</li>
              <li>잉글리시팝은 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집할 때 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</li>
              <li>개인정보 보호법 제22조의2에 따라 만 14세 미만 아동의 개인정보 처리에 동의가 필요한 경우 법정대리인의 동의를 받고, 법정대리인이 동의하였는지를 확인합니다. 법정대리인의 동의를 받기 위해 필요한 최소한의 정보는 관계 법령에서 정하는 범위 내에서 수집할 수 있습니다.</li>
              <li>잉글리시팝은 사상·신념, 노동조합·정당의 가입·탈퇴, 정치적 견해, 건강, 성생활 등 개인정보 보호법에서 정한 민감정보를 원칙적으로 수집·처리하지 않습니다. 다만, 관계 법령에서 허용하거나 정보주체로부터 별도의 동의를 받은 경우에는 예외로 합니다. </li>
            </ul>

            <h3 className={styles.h3}>② 개인정보 수집 방법</h3>
            <ul className={styles.plain}>
              <li>잉글리시팝은 홈페이지 내 가맹문의 및 지원, 가맹운영시스템, 본부운영시스템, 서면양식, 상담, 전화, 팩스, 이벤트 응모, 상품 주문 및 배송 요청 등의 방법을 통해 개인정보를 수집합니다.</li>
              <li>서비스 이용 과정에서 IP Address, 접속로그, 쿠키, 방문기록, 서비스 이용기록, 기기정보 등의 정보가 자동으로 생성되어 수집될 수 있습니다.</li>
            </ul>

            <h3 className={styles.h3}>③ 개인정보 수집 목적 및 항목</h3>
            <p className={styles.lead}>▶ 회원가입 및 서비스 이용 과정에서 필요한 시점에서 수집하는 정보</p>
            <div className={styles.tblWrap}>
              <table>
                <thead>
                  <tr>
                    <th>수집 목적</th>
                    <th>수집하는 개인정보 항목</th>
                    <th>보유 기간</th>
                    <th>법적 근거</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>회원가입</td>
                    <td>
                      <span className={styles.grp}>&lt;가맹점장&gt;</span>
                      <br />- [필수] 이름, 휴대폰 번호, 아이디, 비밀번호, 가맹점명, 사업장 주소, 가맹유형
                      <br />- [선택] 이메일, 가맹점 전화번호, 가맹점 팩스번호, 사업자등록번호, 생년월일, 성별, 원장 사진, 계약자명
                    </td>
                    <td>회원탈퇴 시 원칙적으로 파기합니다. 다만, 불법·편법 행위의 방지 및 대응을 위하여 필요한 정보는 회원탈퇴 후 6개월간 보관 후 파기하며, 관계법령에 따라 보존할 필요가 있는 경우 해당 법령에서 정한 기간 동안 별도 보관합니다.</td>
                    <td>개인정보 보호법 제15조 제1항 제1호(정보주체의 동의), 제15조 제1항 제4호(계약의 이행)</td>
                  </tr>
                  <tr>
                    <td>온라인 학습 서비스 등록 및 이용</td>
                    <td>
                      <span className={styles.grp}>&lt;학생&gt;</span>
                      <br />- [필수] 지점명, 이름, 성별, 아이디, 비밀번호, 학교정보(학교급, 나이), 입회일, 학부모 정보(구분, 이름, 아이디, 비밀번호), 재/휴원상태, 학습 수준, 수강반, 학습 결과(Daily Quest 등 활동 결과), 교사 관찰 기록, Speaking 학습 및 발음평가 파일
                      <br />- [선택] 생년월일, 휴대폰 번호, 비상연락처 및 관계, 영어학습 경험, 학부모 휴대폰 번호, 개인정보 활용 동의 여부, SMS 수신 여부, 입학테스트 신청정보(초등 대상: 테스트 희망 여부, 진행방식)
                      <br />
                      <span className={styles.grp}>&lt;가맹점장&gt;</span>
                      <br />- [필수] 지점명, 이름, 아이디, 비밀번호, 휴대폰 번호
                      <br />- [선택] 이메일, 생년월일, 주소
                      <br />
                      <span className={styles.grp}>&lt;강사&gt;</span>
                      <br />- [필수] 소속 지점명, 이름, 영문이름, 아이디, 비밀번호, 휴대폰 번호, 비상연락처, 권한정보
                      <br />- [선택] 이메일, 자택주소, SMS/알림톡 수신 여부, 이메일 수신 여부
                    </td>
                    <td>회원탈퇴 시 불법, 편법 행위의 방지 및 대응의 목적으로 1개월간 보관 후 즉시 파기됩니다. 단, 결제 내역 등은 별도 보관하며 최대 5년간 보유하도록 합니다.</td>
                    <td>
                      개인정보 보호법 제15조 제1항 제1호(정보주체의 동의), 제15조 제1항 제4호(계약의 이행)
                      <br />
                      <span className={styles.red}>※ 만 14세 미만 아동의 개인정보 처리에 동의가 필요한 경우 제22조의2에 따라 법정대리인의 동의를 받습니다.</span>
                    </td>
                  </tr>
                  <tr>
                    <td>회원관리 (고객상담 및 민원처리)</td>
                    <td>
                      <span className={styles.grp}>&lt;학생&gt;</span>
                      <br />- [필수] 이름, 성별, 학교정보, 아이디, 재/휴원상태, 사이트 가입일, 최종 접속일, 사이트 탈퇴일, 계정삭제 여부, 삭제일시
                      <br />- [선택] 생년월일, 휴대폰 번호, 비상연락처 및 관계, 학부모 정보(구분, 이름, 휴대폰 번호, 아이디)
                      <br />
                      <span className={styles.grp}>&lt;가맹점장&gt;</span>
                      <br />- [필수] 이름, 아이디, 회원상태(재/퇴직 또는 가맹상태), 사이트 가입일, 최종 접속일, 사이트 탈퇴일, 계정삭제 여부, 삭제일시
                      <br />- [선택] 이메일, 생년월일, 성별, 주소, 휴대폰 번호
                      <br />
                      <span className={styles.grp}>&lt;강사&gt;</span>
                      <br />- [필수] 소속 지점명, 이름, 영문이름, 아이디, 재/퇴직상태, 휴대폰 번호, 비상연락처, 권한정보, 사이트가입일, 최종 접속일, 사이트탈퇴일, 계정삭제여부, 삭제일시
                      <br />- [선택] 이메일, 자택주소
                    </td>
                    <td>회원탈퇴 시 불법, 편법 행위의 방지 및 대응의 목적으로 1개월간 보관 후 즉시 파기됩니다. 단, 결제 내역 등은 별도 보관하며 최대 5년간 보유하도록 합니다.</td>
                    <td>개인정보 보호법 제15조 제1항 제1호(정보주체의 동의), 제15조 제1항 제4호(계약의 이행)</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p className={styles.lead}>▶ 서비스 이용 과정에서 추가로 수집하는 정보</p>
            <p>개별 서비스 이용, 이벤트 응모 및 경품 신청 과정에서 해당 서비스 이용자에 한해 추가 개인정보 수집이 발생할 수 있습니다. 개인정보 수집 시 이용자에게 수집하는 개인정보의 항목, 이용목적, 보관기간을 안내하고 동의를 받으며, 동의를 거부할 권리가 있다는 사실 및 동의 거부에 따른 불이익이 있는 경우에는 그 불이익의 내용을 함께 안내합니다.</p>
            <div className={styles.tblWrap}>
              <table>
                <thead>
                  <tr>
                    <th>목적</th>
                    <th>수집항목</th>
                    <th>보유 및 이용기간</th>
                    <th>법적 근거</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>가맹 문의 및 신청</td>
                    <td>[필수] 이름, 연락처, 이메일</td>
                    <td>수집일로부터 1년 또는 동의 철회 시까지</td>
                    <td>개인정보 보호법 제15조 제1항 제1호(정보주체의 동의)</td>
                  </tr>
                  <tr>
                    <td>이벤트 응모 및 경품 발송</td>
                    <td>이벤트 진행 시 별도 안내</td>
                    <td>이벤트 진행 시 별도 안내</td>
                    <td>개인정보 보호법 제15조 제1항 제1호(정보주체의 동의)</td>
                  </tr>
                  <tr>
                    <td>상품 주문 및 배송</td>
                    <td>[필수] 이름, 휴대폰 번호, 이메일, 주소</td>
                    <td>이용목적 달성 후 지체 없이 파기합니다. 다만, 관계법령에 따라 보존할 필요가 있는 경우 해당 법령에서 정한 기간 동안 별도 보관합니다.</td>
                    <td>개인정보 보호법 제15조 제1항 제4호(계약의 이행), 전자상거래 등에서의 소비자보호에 관한 법률 제6조</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p className={styles.lead}>▶ 서비스 이용 과정에서 생성되는 정보</p>
            <div className={styles.tblWrap}>
              <table>
                <thead>
                  <tr>
                    <th>구분</th>
                    <th>수집하는 개인정보 항목</th>
                    <th>보유 기간</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>서비스 이용 통계, 회원관리 등</td>
                    <td>
                      IP Address, 접속로그, 쿠키, MAC주소, 방문기록, 서비스 이용기록, 불량 이용기록
                      <br />※ 모바일 서비스 이용 시 모바일 기기 정보(고유기기식별정보, OS버전)
                    </td>
                    <td>
                      회원 탈퇴 또는 계약 종료 시 지체 없이 파기합니다.
                      <br />※ 쿠키의 경우, 브라우저 종료 시 또는 로그아웃 시 만료
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h3 className={styles.h3}>④ 쿠키의 설치·운영 및 거부에 관한 사항</h3>
            <ul className={styles.plain}>
              <li>쿠키란 웹사이트를 운영하는 데 이용되는 서버가 이용자의 웹 브라우저에 보내는 소량의 정보로, 이용자의 기기에 저장될 수 있습니다.</li>
            </ul>
            <h4 className={styles.h4}>쿠키의 사용 목적</h4>
            <ul className={styles.plain}>
              <li>이용자가 웹사이트를 다시 방문할 때 이용자가 설정한 서비스 이용 환경을 유지하여 보다 편리한 서비스를 제공합니다.</li>
              <li>방문 서비스 정보, 접속 시간 및 빈도, 서비스 이용 과정에서 생성되거나 입력된 정보 등을 분석하여 이용자의 서비스 이용 편의 향상 및 맞춤형 서비스 제공 등에 활용할 수 있습니다.</li>
            </ul>
            <div className={styles.tblWrap}>
              <table>
                <thead>
                  <tr>
                    <th>수집장치 명칭</th>
                    <th>수집장치 종류</th>
                    <th>수집해가는 사업자</th>
                    <th>수집해가는 행태정보 항목</th>
                    <th>수집 목적</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>쿠키(Cookie)</td>
                    <td>브라우저 쿠키</td>
                    <td>회사 및 제휴 사업자</td>
                    <td>방문기록, 서비스 이용기록, 로그인 상태, 접속 설정 정보 등</td>
                    <td>서비스 이용 환경 유지, 이용자 편의 제공</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p>이용자는 웹 브라우저의 쿠키 설정을 통해 쿠키의 저장을 허용하거나 차단할 수 있습니다. 다만, 쿠키 저장을 거부할 경우 로그인 상태 유지 등 일부 서비스 이용이 제한될 수 있습니다.</p>
            <p className={styles.lead}>• 주요 웹 브라우저의 쿠키 설정 방법은 다음과 같습니다.</p>
            <ul className={styles.plain}>
              <li>Chrome: 설정 &gt; 개인정보 및 보안 &gt; 서드 파티 쿠키</li>
              <li>Microsoft Edge: 설정 &gt; 쿠키 및 사이트 권한 &gt; 쿠키 및 사이트 데이터 관리 및 삭제</li>
              <li>Safari: 설정 &gt; 개인정보 보호 &gt; 웹사이트 데이터 관리</li>
            </ul>
            <p className={styles.note}>※ 브라우저 버전에 따라 메뉴의 명칭과 설정 경로가 달라질 수 있으며, 자세한 내용은 각 브라우저 제공업체의 안내를 확인하시기 바랍니다.</p>
          </section>

          {/* 2. 수집한 개인정보의 이용 */}
          <section className={styles.article}>
            <h2 className={styles.h2}>2. 수집한 개인정보의 이용</h2>
            <p>잉글리시팝은 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 아래의 목적 범위 내에서 이용하며, 이용 목적이 변경되는 경우에는 개인정보 보호법 등 관계 법령에 따라 필요한 조치를 이행합니다.</p>
            <div className={styles.tblWrap}>
              <table>
                <thead>
                  <tr>
                    <th>구분</th>
                    <th>이용 목적</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>회원 관리</td>
                    <td>회원 가입 의사 확인, 회원제 서비스 제공에 따른 본인 식별, 회원자격 유지·관리, 가입횟수 제한, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의 여부 확인, 각종 고지·통지, 고객 상담 및 불만 처리, 분쟁 조정을 위한 기록 보존 등</td>
                  </tr>
                  <tr>
                    <td>서비스 제공에 관한 계약의 이행 및 서비스 제공에 따른 요금정산</td>
                    <td>서비스 제공, 콘텐츠 제공, 맞춤서비스 제공, 물품배송, 계약서·청구서 발송, 요금결제·정산, 채권추심 등</td>
                  </tr>
                  <tr>
                    <td>마케팅 및 광고에 활용</td>
                    <td>신규 서비스 및 제품 안내, 맞춤 서비스 제공, 이벤트 등 광고성 정보 전달, 서비스 이용 통계 분석 등</td>
                  </tr>
                  <tr>
                    <td>고충처리</td>
                    <td>민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지, 처리결과 통보 등</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* 3. 개인정보의 제공 및 위탁 */}
          <section className={styles.article}>
            <h2 className={styles.h2}>3. 개인정보의 제공 및 위탁</h2>
            <p>잉글리시팝은 원칙적으로 정보주체의 개인정보를 제3자에게 제공하지 않습니다. 다만, 정보주체의 동의를 받은 경우 또는 개인정보 보호법 등 관계 법령에서 개인정보 제공을 허용하는 경우에는 필요한 범위 내에서 개인정보를 제공할 수 있습니다.</p>
            <p>개인정보를 제3자에게 제공하기 위해 정보주체의 동의를 받는 경우에는 개인정보를 제공받는 자, 제공받는 자의 개인정보 이용 목적, 제공하는 개인정보 항목, 제공받는 자의 개인정보 보유·이용기간, 동의를 거부할 권리 및 동의 거부에 따른 불이익이 있는 경우 그 내용을 사전에 안내하고 동의를 받습니다.</p>

            <h3 className={styles.h3}>① 개인정보의 제3자 제공</h3>
            <div className={styles.tblWrap}>
              <table>
                <thead>
                  <tr>
                    <th>제공받는 자</th>
                    <th>제공 목적</th>
                    <th>제공 항목</th>
                    <th>보유기간</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>정보주체가 등록한 잉글리시팝 가맹점</td>
                    <td>학생 등록, 학습관리, 출결·성적관리, 학부모 상담 등 교육서비스 제공</td>
                    <td>학생 이름, 아이디, 학년, 학습수준, 학습결과, 학부모 연락처 등</td>
                    <td>가맹점 이용계약 또는 학습계약 종료 시까지</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ul className={styles.plain}>
              <li>잉글리시팝은 개인정보를 수집·이용 목적의 범위 내에서 처리하며, 해당 범위를 초과하여 이용하거나 제3자에게 제공하지 않습니다.</li>
              <li>다만, 정보주체의 별도 동의를 받은 경우 또는 법률에 특별한 규정이 있는 경우 등 개인정보 보호법에서 허용하는 경우에는 개인정보를 제3자에게 제공할 수 있습니다.</li>
            </ul>

            <h3 className={styles.h3}>② 개인정보처리의 위탁</h3>
            <p>잉글리시팝은 이용자에게 더 나은 서비스를 제공하기 위하여 다음과 같은 업무를 위탁하고 있습니다.</p>
            <div className={styles.tblWrap}>
              <table>
                <thead>
                  <tr>
                    <th>수탁자</th>
                    <th>위탁업무 내용</th>
                    <th>개인정보의 보유 및 이용기간</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>㈜케이지이니시스</td>
                    <td>결제 시 본인인증 및 거래</td>
                    <td>회원 탈퇴 또는 위탁계약 종료 시까지</td>
                  </tr>
                  <tr>
                    <td>씨제이올리브네트웍스㈜</td>
                    <td>마케팅 정보 SMS 발송</td>
                    <td>회원 탈퇴 또는 위탁계약 종료 시까지</td>
                  </tr>
                  <tr>
                    <td>협진출판물류</td>
                    <td>물품 발송</td>
                    <td>회원 탈퇴 또는 위탁계약 종료 시까지</td>
                  </tr>
                  <tr>
                    <td>㈜대한통운</td>
                    <td>물품배송</td>
                    <td>회원 탈퇴 또는 위탁계약 종료 시까지</td>
                  </tr>
                  <tr>
                    <td>Amazon Web Services</td>
                    <td>서비스 제공을 위한 클라우드 인프라 제공, 시스템 운영 및 데이터 보관</td>
                    <td>위탁계약 종료 또는 이용목적 달성 시까지</td>
                  </tr>
                  <tr>
                    <td>㈜메가존클라우드</td>
                    <td>클라우드 자원 운영, 시스템 유지보수 및 기술지원</td>
                    <td>위탁계약 종료 또는 이용목적 달성 시까지</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ul className={styles.plain}>
              <li>잉글리시팝은 위탁계약 체결 시 개인정보 보호법 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</li>
              <li>위탁업무의 내용이나 수탁자가 변경될 경우에는 지체 없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</li>
            </ul>
          </section>

          {/* 4. 개인정보의 파기 */}
          <section className={styles.article}>
            <h2 className={styles.h2}>4. 개인정보의 파기</h2>

            <h3 className={styles.h3}>① 개인정보의 파기</h3>
            <ul className={styles.plain}>
              <li>잉글리시팝은 개인정보의 보유기간이 경과하거나 개인정보의 처리 목적이 달성되는 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.</li>
              <li>다만, 관계 법령에 따라 개인정보를 보존하여야 하는 경우 또는 정보주체로부터 별도의 보유·이용기간에 대한 동의를 받은 경우에는 해당 기간 동안 개인정보를 안전하게 보관합니다.</li>
              <li>관계 법령에 따라 개인정보를 파기하지 않고 보존하는 경우에는 해당 개인정보를 다른 개인정보와 분리하여 저장·관리합니다.</li>
            </ul>

            <h3 className={styles.h3}>② 관계법령에 따른 개인정보 보존</h3>
            <div className={styles.tblWrap}>
              <table>
                <thead>
                  <tr>
                    <th>관계법령</th>
                    <th>보존항목</th>
                    <th>보존기간</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>전자상거래 등에서의 소비자보호에 관한 법률 제6조</td>
                    <td>표시·광고에 관한 기록</td>
                    <td>6개월</td>
                  </tr>
                  <tr>
                    <td>전자상거래 등에서의 소비자보호에 관한 법률 제6조</td>
                    <td>계약 또는 청약철회 등에 관한 기록</td>
                    <td>5년</td>
                  </tr>
                  <tr>
                    <td>전자상거래 등에서의 소비자보호에 관한 법률 제6조</td>
                    <td>대금결제 및 재화 등의 공급에 관한 기록</td>
                    <td>5년</td>
                  </tr>
                  <tr>
                    <td>전자상거래 등에서의 소비자보호에 관한 법률 제6조</td>
                    <td>소비자의 불만 또는 분쟁처리에 관한 기록</td>
                    <td>3년</td>
                  </tr>
                  <tr>
                    <td>통신비밀보호법</td>
                    <td>인터넷 로그기록자료, 접속지 추적자료</td>
                    <td>3개월</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h3 className={styles.h3}>③ 개인정보 파기 절차 및 방법</h3>
            <ul className={styles.plain}>
              <li>종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.</li>
              <li>전자적 파일 형태로 저장된 개인정보는 복구 또는 재생되지 않도록 안전한 방법으로 삭제합니다.</li>
            </ul>
          </section>

          {/* 5. 개인정보 전담조직 운영 */}
          <section className={styles.article}>
            <h2 className={styles.h2}>5. 개인정보 전담조직 운영</h2>

            <h3 className={styles.h3}>① 개인정보 보호책임자 및 담당부서</h3>
            <p>잉글리시팝은 이용자의 개인정보 처리에 관한 업무를 총괄하여 책임지고, 개인정보 보호 관련 문의, 불만처리 및 피해구제를 위하여 개인정보 보호책임자와 담당부서를 지정하여 운영하고 있습니다.</p>
            <div className={styles.tblWrap}>
              <table>
                <thead>
                  <tr>
                    <th>구분</th>
                    <th>내용</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>개인정보보호책임자(CPO)</td>
                    <td>이정우 CP</td>
                  </tr>
                  <tr>
                    <td>소속</td>
                    <td>IT전략 Core</td>
                  </tr>
                  <tr>
                    <td>개인정보 담당부서</td>
                    <td>정보보안 Cell</td>
                  </tr>
                  <tr>
                    <td>문의</td>
                    <td>전화 : 1544-0554 / 이메일 : privacy@visang.com</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p>이용자는 잉글리시팝의 서비스를 이용하면서 발생하는 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다.</p>

            <h3 className={styles.h3}>② 권익침해 구제방법</h3>
            <ul className={styles.plain}>
              <li>개인정보 침해에 대한 피해구제, 신고, 상담이 필요하신 경우에는 아래 기관에 문의하셔서 도움받으실 수 있습니다.</li>
              <li>아래 기관은 잉글리시팝과는 별개의 기관입니다.</li>
            </ul>
            <div className={styles.tblWrap}>
              <table>
                <thead>
                  <tr>
                    <th>구분</th>
                    <th>홈페이지</th>
                    <th>전화</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>개인정보 침해신고센터 (한국인터넷진흥원 운영)</td>
                    <td>privacy.kisa.or.kr</td>
                    <td>(국번없이) 118</td>
                  </tr>
                  <tr>
                    <td>개인정보 분쟁조정위원회</td>
                    <td>www.kopico.go.kr</td>
                    <td>(국번없이) 1833-6972</td>
                  </tr>
                  <tr>
                    <td>대검찰청 사이버수사과</td>
                    <td>www.spo.go.kr</td>
                    <td>(국번없이) 1301</td>
                  </tr>
                  <tr>
                    <td>사이버범죄 신고시스템(ECRM)</td>
                    <td>ecrm.police.go.kr</td>
                    <td>(국번없이) 182</td>
                  </tr>
                  <tr>
                    <td>경찰청 사이버수사국</td>
                    <td>cyberbureau.police.go.kr</td>
                    <td>(국번없이) 182</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* 6. 이용자·법정대리인의 권리행사방법 및 의무 */}
          <section className={styles.article}>
            <h2 className={styles.h2}>6. 이용자·법정대리인의 권리행사방법 및 의무</h2>

            <h3 className={styles.h3}>① 권리행사방법</h3>
            <p>이용자는 잉글리시팝에 대해 언제든지 개인정보의 열람, 정정·삭제, 처리정지, 동의 철회 등의 권리를 행사할 수 있으며, 다음의 방법을 통해 요청할 수 있습니다.</p>
            <div className={styles.tblWrap}>
              <table>
                <thead>
                  <tr>
                    <th>구분</th>
                    <th>요청 방법</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>개인정보 열람, 정정·삭제, 처리정지 등의 요구</td>
                    <td>가맹점 또는 개인정보 담당부서를 통하여 개인정보 열람, 정정·삭제, 처리정지 등을 요청할 수 있습니다.</td>
                  </tr>
                  <tr>
                    <td>개인정보 조회/수정</td>
                    <td>
                      <span className={styles.grp}>&lt;가맹점장/강사&gt;</span> 운영관리페이지 &gt; 가맹점관리 메뉴에서 조회 및 수정 가능
                      <br />
                      <span className={styles.grp}>&lt;학생/학부모&gt;</span> 가맹점을 통하여 개인정보 열람, 정정·삭제 등을 요청할 수 있습니다.
                    </td>
                  </tr>
                  <tr>
                    <td>동의 철회</td>
                    <td>운영관리페이지 &gt; 회원관리 메뉴에서 개인정보 마케팅 활용 동의를 변경할 수 있습니다.</td>
                  </tr>
                  <tr>
                    <td>회원 탈퇴</td>
                    <td>
                      <span className={styles.grp}>&lt;가맹점장&gt;</span> 본사 고객센터를 통해 회원 탈퇴 신청 가능
                      <br />
                      <span className={styles.grp}>&lt;강사/학생/학부모&gt;</span> 가맹점을 통하여 개인정보 삭제 및 회원 탈퇴를 요청할 수 있습니다.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ul className={styles.plain}>
              <li>개인정보의 정확성을 위하여 이용자가 개인정보의 정정 또는 삭제를 요구한 경우, 해당 요구사항의 처리가 완료될 때까지 해당 개인정보를 이용하거나 제공하지 않습니다. 다만, 잘못된 개인정보를 이미 제3자에게 제공한 경우에는 정정·삭제 처리 결과를 해당 제3자에게 지체 없이 알려 필요한 조치가 이루어지도록 합니다.</li>
              <li>만 14세 미만 아동의 법정대리인은 해당 아동의 개인정보에 대하여 법령에서 정한 권리를 행사할 수 있습니다.</li>
              <li>이용자의 권리 행사는 이용자의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 할 수 있습니다. 이 경우 「개인정보 처리 방법에 관한 고시」 별지 제11호 서식에 따른 위임장을 제출하여야 합니다.</li>
              <li>개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항 및 제37조 제2항에 따라 정보주체의 권리가 제한될 수 있습니다.</li>
              <li>개인정보의 정정 및 삭제 요구는 다른 법령에서 해당 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.</li>
              <li>잉글리시팝은 이용자의 권리에 따른 열람, 정정·삭제, 처리정지 등의 요구를 받은 경우 요구한 자가 본인이거나 정당한 대리인인지를 확인합니다.</li>
            </ul>

            <h3 className={styles.h3}>② 이용자의 의무</h3>
            <ul className={styles.plain}>
              <li>이용자는 개인정보 보호법 등 관계법령을 위반하여 잉글리시팝이 처리하고 있는 정보주체 본인이나 타인의 개인정보 및 사생활을 침해하여서는 아니 됩니다.</li>
            </ul>
          </section>

          {/* 7. 개인정보의 안전성 확보조치 */}
          <section className={styles.article}>
            <h2 className={styles.h2}>7. 개인정보의 안전성 확보조치</h2>
            <p>잉글리시팝은 이용자의 개인정보를 소중히 여기며, 개인정보를 처리함에 있어서 다음과 같은 노력을 하고 있습니다.</p>

            <h3 className={styles.h3}>① 내부관리계획의 수립 및 시행</h3>
            <p>개인정보의 안전한 처리를 위한 기준으로 내부관리계획을 수립 및 시행하고 있습니다.</p>

            <h3 className={styles.h3}>② 개인정보 취급자 최소화 및 접근 통제</h3>
            <p>개인정보를 처리하는 담당자를 필요한 범위로 최소화하고 있으며, 개인정보처리시스템 및 데이터베이스에 대한 접근권한을 업무상 필요한 범위로 제한하고 있습니다. 또한 개인정보에 대한 불필요한 접근을 방지하기 위하여 접근통제 기준을 마련하고 관리하고 있습니다.</p>

            <h3 className={styles.h3}>③ 정기 교육</h3>
            <p>개인정보를 처리하는 담당자를 대상으로 정기적인 개인정보 보호 교육을 실시하고, 임직원을 대상으로 개인정보 보호 관련 주요 사항을 안내하고 있습니다.</p>

            <h3 className={styles.h3}>④ 해킹 및 악성프로그램 등에 대한 보호</h3>
            <p>외부의 불법적인 접근 및 침해사고를 방지하기 위하여 접근통제 등 필요한 보호조치를 시행하고 있으며, 개인정보 훼손에 대비하여 정기적인 백업과 악성프로그램 방지를 위한 보안조치를 시행하고 있습니다.</p>

            <h3 className={styles.h3}>⑤ 개인정보의 암호화</h3>
            <p>개인정보 전송 시 암호화된 통신구간을 이용하며, 비밀번호 등 중요정보는 관련 법령 및 내부 기준에 따라 안전한 방법으로 보호하고 있습니다.</p>

            <h3 className={styles.h3}>⑥ 물리적 접근 통제</h3>
            <p>개인정보가 포함된 문서 및 보조저장매체 등에 대한 접근을 통제하고 있으며, 필요한 경우 잠금장치가 있는 안전한 장소에 보관하는 등 물리적 보호조치를 시행하고 있습니다.</p>
          </section>

          {/* 8. 개인정보 처리방침의 변경 */}
          <section className={styles.article}>
            <h2 className={styles.h2}>8. 개인정보 처리방침의 변경</h2>
            <ul className={styles.plain}>
              <li>개인정보 처리방침의 내용이 추가, 삭제 또는 수정되는 경우에는 시행일 최소 7일 전에 홈페이지 공지사항 등을 통하여 변경 내용을 안내합니다. 다만, 이용자의 권리 또는 의무에 중요한 영향을 미치는 내용이 변경되는 경우에는 시행일 최소 30일 전에 안내합니다.</li>
            </ul>
            <div className={styles.contactBox}>
              <b>공고일</b> : 2026.06.24
              <br />
              <b>시행일</b> : 2026.07.01
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
}
